const HaltungsaenderungMetadaten = () => {
    return {
        halterZiehtUm:{
            value: null,
            valide: null,
        },
        tiereZiehenUm:{
            value: "",
            valide: null,
        },
        wohnortIstHaltungsort:{
            value: null,
            valide: null,
        },
        alleTiereZiehenUm:{
            value: null,
            valide: null,
        },
    }
}
export default HaltungsaenderungMetadaten;